import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-excursions',
  	templateUrl: './toolcards-excursions.component.html',
  	styleUrls: ['./toolcards-excursions.component.scss']
})
export class ToolcardsExcursionsComponent implements OnInit {
	public env;
  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
